/* eslint-disable */
import React from 'react'

// Custom
import { useTranslation } from 'react-i18next';

// Types
import { TCustomGFIActionProps } from '@/@types/views/map';

// OL
import { transform as OlTransform } from "ol/proj";

// MUI
import MapIcon from '@mui/icons-material/Map';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

const ShowOnGoogleMapsListItem = (props: TCustomGFIActionProps) => {

    const { t } = useTranslation();

    const { featureData, handleCloseMenu } = props;

    const handleShowOnGoogleMaps = (position: [number, number]) => {
        const positionLonLat = OlTransform(position, 'EPSG:3857', 'EPSG:4326');
        const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${positionLonLat[1]},${positionLonLat[0]}`;
        window.open(googleMapsUrl, '_blank');
    }

    const handleClick = () => {
        handleShowOnGoogleMaps(featureData.position);
        if (handleCloseMenu) {
            handleCloseMenu();
        }
    }

    return (
        <MenuItem
            onClick={handleClick}
        >
            <ListItemIcon>
                <MapIcon color='primary' fontSize='small'/>
            </ListItemIcon>
            <ListItemText>
                {t("buttons.show_on_google_maps")}
            </ListItemText>
        </MenuItem>
    )

}

export default ShowOnGoogleMapsListItem;
